import gql from 'graphql-tag'

export const abandonedCart = gql`
  query abandonedCart($cartId: String) {
    getAbandonedCart(cartId: $cartId) {
      email
      available_payment_methods {
        code
        title
        __typename
      }
      applied_gift_cards {
        applied_balance {
          value
          __typename
        }
        code
        current_balance {
          value
          __typename
        }
        expiration_date
        __typename
      }
      items {
        id
        quantity
        prices {
          total_item_discount {
            value
            __typename
          }
          price {
            value
            __typename
          }
          row_total_including_tax {
            value
            __typename
          }
          row_total {
            value
            __typename
          }
          __typename
        }
        product {
          id
          name
          sku
          url_key
          canonical_url
          url_rewrites {
            url
            __typename
          }
          short_description {
            html
            __typename
          }
          image {
            label
            url
            __typename
          }
          small_image {
            label
            url
            __typename
          }
          thumbnail {
            label
            url
            __typename
          }
          description {
            html
            __typename
          }
          new_from_date
          new_to_date
          status
          stock_status
          meta_description
          meta_keyword
          meta_title
          categories {
            id
            __typename
          }
          price {
            regularPrice {
              amount {
                currency
                value
                __typename
              }
              __typename
            }
            minimalPrice {
              amount {
                currency
                value
                __typename
              }
              __typename
            }
            maximalPrice {
              amount {
                currency
                value
                __typename
              }
              __typename
            }
            __typename
          }
          price_range {
            maximum_price {
              discount {
                amount_off
                percent_off
                __typename
              }
              final_price {
                currency
                value
                __typename
              }
              fixed_product_taxes {
                amount {
                  currency
                  value
                  __typename
                }
                label
                __typename
              }
              regular_price {
                currency
                value
                __typename
              }
              __typename
            }
            minimum_price {
              discount {
                amount_off
                percent_off
                __typename
              }
              final_price {
                currency
                value
                __typename
              }
              fixed_product_taxes {
                amount {
                  currency
                  value
                  __typename
                }
                label
                __typename
              }
              regular_price {
                currency
                value
                __typename
              }
              __typename
            }
            __typename
          }
          pwa_layout
          __typename
          crosssell_products {
            id
            name
            sku
            url_key
            canonical_url
            url_rewrites {
              url
              __typename
            }
            short_description {
              html
              __typename
            }
            image {
              label
              url
              __typename
            }
            small_image {
              label
              url
              __typename
            }
            thumbnail {
              label
              url
              __typename
            }
            description {
              html
              __typename
            }
            new_from_date
            new_to_date
            status
            stock_status
            meta_description
            meta_keyword
            meta_title
            categories {
              id
              __typename
            }
            price {
              regularPrice {
                amount {
                  currency
                  value
                  __typename
                }
                __typename
              }
              minimalPrice {
                amount {
                  currency
                  value
                  __typename
                }
                __typename
              }
              maximalPrice {
                amount {
                  currency
                  value
                  __typename
                }
                __typename
              }
              __typename
            }
            price_range {
              maximum_price {
                discount {
                  amount_off
                  percent_off
                  __typename
                }
                final_price {
                  currency
                  value
                  __typename
                }
                fixed_product_taxes {
                  amount {
                    currency
                    value
                    __typename
                  }
                  label
                  __typename
                }
                regular_price {
                  currency
                  value
                  __typename
                }
                __typename
              }
              minimum_price {
                discount {
                  amount_off
                  percent_off
                  __typename
                }
                final_price {
                  currency
                  value
                  __typename
                }
                fixed_product_taxes {
                  amount {
                    currency
                    value
                    __typename
                  }
                  label
                  __typename
                }
                regular_price {
                  currency
                  value
                  __typename
                }
                __typename
              }
              __typename
            }
            pwa_layout
            __typename
            visiture_custom_attributes
            media_gallery_entries {
              id
              media_type
              label
              position
              disabled
              file
              video_content {
                media_type
                video_provider
                video_url
                video_title
                video_description
                video_metadata
                __typename
              }
              __typename
            }
          }
          visiture_custom_attributes
          ... on CustomizableProductInterface {
            options {
              title
              required
              sort_order
              option_id
              ... on CustomizableFieldOption {
                field_value: value {
                  max_characters
                  price
                  price_type
                  sku
                  __typename
                }
                __typename
              }
              ... on CustomizableMultipleOption {
                multiple_value: value {
                  option_type_id
                  price_type
                  price
                  sku
                  sort_order
                  title
                  __typename
                }
                __typename
              }
              ... on CustomizableAreaOption {
                area_value: value {
                  max_characters
                  price
                  price_type
                  sku
                  __typename
                }
                __typename
              }
              ... on CustomizableDropDownOption {
                dropdown_value: value {
                  option_type_id
                  price
                  price_type
                  sku
                  sort_order
                  title
                  __typename
                }
                __typename
              }
              ... on CustomizableCheckboxOption {
                checkbox_value: value {
                  option_type_id
                  price
                  price_type
                  sku
                  sort_order
                  title
                  __typename
                }
                __typename
              }
              ... on CustomizableRadioOption {
                radio_value: value {
                  title
                  option_type_id
                  price
                  price_type
                  sku
                  sort_order
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
        }
        frequency_in_cart
        promo_qty
        package_qty
        associated_promo_hash
        ... on ConfigurableCartItem {
          variant_product {
            id
            name
            sku
            url_key
            canonical_url
            url_rewrites {
              url
              __typename
            }
            short_description {
              html
              __typename
            }
            image {
              label
              url
              __typename
            }
            small_image {
              label
              url
              __typename
            }
            thumbnail {
              label
              url
              __typename
            }
            description {
              html
              __typename
            }
            new_from_date
            new_to_date
            status
            stock_status
            meta_description
            meta_keyword
            meta_title
            categories {
              id
              __typename
            }
            price {
              regularPrice {
                amount {
                  currency
                  value
                  __typename
                }
                __typename
              }
              minimalPrice {
                amount {
                  currency
                  value
                  __typename
                }
                __typename
              }
              maximalPrice {
                amount {
                  currency
                  value
                  __typename
                }
                __typename
              }
              __typename
            }
            price_range {
              maximum_price {
                discount {
                  amount_off
                  percent_off
                  __typename
                }
                final_price {
                  currency
                  value
                  __typename
                }
                fixed_product_taxes {
                  amount {
                    currency
                    value
                    __typename
                  }
                  label
                  __typename
                }
                regular_price {
                  currency
                  value
                  __typename
                }
                __typename
              }
              minimum_price {
                discount {
                  amount_off
                  percent_off
                  __typename
                }
                final_price {
                  currency
                  value
                  __typename
                }
                fixed_product_taxes {
                  amount {
                    currency
                    value
                    __typename
                  }
                  label
                  __typename
                }
                regular_price {
                  currency
                  value
                  __typename
                }
                __typename
              }
              __typename
            }
            pwa_layout
            __typename
            visiture_custom_attributes
          }
          configurable_options {
            id
            option_label
            value_id
            value_label
            __typename
          }
          __typename
        }
        ... on SimpleCartItem {
          customizable_options {
            id
            label
            values {
              id
              label
              price {
                type
                units
                value
                __typename
              }
              value
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      prices {
        discount_amount {
          value
          currency
          __typename
        }
        grand_total {
          value
          currency
          __typename
        }
        applied_taxes {
          amount {
            currency
            value
            __typename
          }
          label
          __typename
        }
        subtotal_excluding_tax {
          value
          currency
          __typename
        }
        subtotal_including_tax {
          value
          currency
          __typename
        }
        subtotal_with_discount_excluding_tax {
          value
          currency
          __typename
        }
        __typename
      }
      shipping_addresses {
        customer_address_id
        firstname
        lastname
        street
        city
        postcode
        telephone
        company
        region {
          code
          label
          __typename
        }
        country {
          code
          label
          __typename
        }
        available_shipping_methods {
          amount {
            currency
            value
            __typename
          }
          available
          base_amount {
            value
            currency
            __typename
          }
          carrier_code
          carrier_title
          error_message
          method_code
          method_title
          price_excl_tax {
            value
            currency
            __typename
          }
          price_incl_tax {
            value
            currency
            __typename
          }
          __typename
        }
        selected_shipping_method {
          amount {
            value
            currency
            __typename
          }
          base_amount {
            value
            currency
            __typename
          }
          carrier_code
          carrier_title
          method_code
          method_title
          __typename
        }
        __typename
      }
      billing_address {
        customer_address_id
        city
        country {
          code
          label
          __typename
        }
        firstname
        lastname
        postcode
        company
        region {
          code
          label
          __typename
        }
        street
        telephone
        __typename
      }
      applied_coupon {
        code
        __typename
      }
      __typename
    }
  }
`

export const mergeAbandonedCarts = gql`
  mutation mergeAbandonedCarts(
    $sourceCartId: String!
    $destinationCartId: String!
  ) {
    mergeAbandonedCart(
      input: {
        sourceCartId: $sourceCartId
        destinationCartId: $destinationCartId
      }
    ) {
      id
    }
  }
`
